var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Heart",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.375
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3134395,18.0459049 L1.52443954,8.87923824 C-0.0597509272,7.29629358 -0.452349335,4.87680895 0.550022872,2.87415491 L0.550022872,2.87415491 C1.29768241,1.3792661 2.71831477,0.334867269 4.36817344,0.0671851901 C6.01803212,-0.200496889 7.69599623,0.341168737 8.87793954,1.52298824 L10.3134395,2.95757158 L11.7489395,1.52298824 C12.9308829,0.341168737 14.608847,-0.200496889 16.2587056,0.0671851901 C17.9085643,0.334867269 19.3291967,1.3792661 20.0768562,2.87415491 L20.0768562,2.87415491 C21.0778256,4.87595612 20.6857045,7.29366739 19.1033562,8.87648824 L10.3134395,18.0459049 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.76c1dcaf147c5155048fb0f477e5e00d.svg";
export { ForwardRef as ReactComponent };